import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const NOTIFY_TYPES = new Set(["info", "error"]);

export default function AppNotifier() {
  const messages = useSelector((state) => state.user?.messages ?? []);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const last = messages[messages.length - 1];
    if (!last || !NOTIFY_TYPES.has(last.type) || !last.message) {
      return;
    }
    setToast({
      message: last.message,
      severity: last.type === "error" ? "error" : "success",
      key: Date.now(),
    });
  }, [messages]);

  if (!toast) return null;

  return (
    <Snackbar
      key={toast.key}
      open
      autoHideDuration={4500}
      onClose={() => setToast(null)}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ zIndex: 1600 }}
    >
      <Alert
        onClose={() => setToast(null)}
        severity={toast.severity}
        variant="filled"
        sx={{ width: "100%", maxWidth: "min(92vw, 420px)" }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
}
